import "./GeographyData.scss";

import { Typography } from "../../ui";

function GeographyData({name, value, color}) {
  return (
    <div className="GeographyData">
      <div className={"cube"} style={{ backgroundColor: color }}></div>
      <div className="city">
        <Typography variant="body1" color="dark-gray">
          {name}
        </Typography>
      </div>
      <div className="percent">
        <Typography variant="body1" color="dark-gray">
          {value + "%"}
        </Typography>
      </div>
    </div>
  );
}

export default GeographyData;
